import React from 'react';
import { ListGroup, ListGroupItem } from 'reactstrap';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';

const DragHandle = SortableHandle(() => <span className="drag-handle">::</span>);
const LockHandle = SortableHandle(() => <span className="drag-handle"><i className="fa fa-lock"/></span>);

const SortableItem = SortableElement(({value, count, fade, disabled, locked}) => {
  return <ListGroupItem
    className={`draggable-element ${fade ? 'fader' : ''}`}
    color='info'
  >
    <span className='draggable-count'>
      {count}
    </span>
    {value}
    {locked ? <LockHandle /> : <DragHandle /> }
  </ListGroupItem>
});

const SortableList = SortableContainer(({items, fader, locked}) => {
  return (
    <div className='sample-element-scrollable sortable-pad'>
      <ListGroup>
        {items.map((value, index) => (
          <SortableItem
            key={`item-${index}`}
            index={index}
            value={value}
            count={index + 1}
            fade={index === fader}
            disabled={locked}
            locked={locked}
          />
        ))}
      </ListGroup>
    </div>
  );
})

export default class SortableElements extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      fadeIn: null
    }
  }

  onSortEnd = ({oldIndex, newIndex, collection}, e) => {
    this.setState({ fadeIn: newIndex });
    this.props.update({oldIndex, newIndex, collection}, e);
  }

  componentDidUpdate(prevProps, prevState) {
    setTimeout(() => {
      this.setState({ fadeIn: null });
    }, 1000);
  }

  render() {
    return (
      <SortableList
        items={this.props.items}
        fader={this.state.fadeIn}
        locked={this.props.locked}
        onSortEnd={this.onSortEnd}
        helperClass='dragged'
      />
    );
  }
}
